export interface TocHeading {
  id: string;
  text: string;
  level: number;
}

export const extractHeadings = (content: string): TocHeading[] => {
  const headings: TocHeading[] = [];
  const lines = content.split('\n');
  
  lines.forEach((line) => {
    // Match markdown headings (## or ###)
    const match = line.match(/^(#{2,3})\s+(.+)$/);
    if (match) {
      const level = match[1].length;
      const text = match[2].trim();
      const id = text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      
      headings.push({ id, text, level });
    }
  });
  
  return headings;
};

export const addHeadingIds = (content: string): string => {
  return content.replace(/^(#{2,3})\s+(.+)$/gm, (match, hashes, text) => {
    const id = text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return `${hashes} ${text} {#${id}}`;
  });
};
